let loaded = false;

/**
 * Fetches the analysis CSS from scribe-api and injects it into the document head.
 * Only fetches once — subsequent calls are no-ops.
 */
export async function loadAnalysisCss(): Promise<void> {
	if (loaded) return;
	loaded = true;

	try {
		const url = window.env.VITE_SCRIBE_URL + "/api/styles/analysis.css";
		const response = await fetch(url);
		if (!response.ok) {
			loaded = false;
			return;
		}

		const css = await response.text();
		const style = document.createElement("style");
		style.setAttribute("data-source", "scribe-analysis");
		style.textContent = css;
		document.head.appendChild(style);
	} catch {
		// Allow retry on next call if fetch failed
		loaded = false;
	}
}
